import PricingPackage from "./PricingPackage";

export default PricingPackage;
